<div class="section-value">
  @if (isEmpty) {
    <p class="section-value__empty">{{ 'activity.ai_adjustment.compare.no_content' | translate }}</p>
  } @else {
    @if (title) {
      <p class="section-value__title">{{ title }}</p>
    }
    @if (subtitle) {
      <p class="section-value__subtitle">{{ subtitle }}</p>
    }
    @if (content) {
      <!-- Plain innerHTML so Angular sanitizes: this is model output. -->
      <div class="section-value__content" [innerHTML]="content"></div>
    }
    @for (list of lists; track $index) {
      @if (list.labelKey) {
        <p class="section-value__list-label">{{ list.labelKey | translate: { count: list.items.length } }}</p>
      }
      <ul class="section-value__list">
        @for (item of list.items; track $index) {
          <li>{{ item }}</li>
        }
      </ul>
    }
  }
</div>
